import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import Applications from "@/components/Applications";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Features />
        <Applications />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
